import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";
import { ALCOHOL_NOTICE, formatMoney } from "../config/siteConfig";

function Main() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="main">
      <main>
        <section className="hero-section">
          <div className="container">
            <p className="hero-kicker">Objects for everyday rituals</p>
            <h1>Material-led homeware and small pleasures</h1>
            <p>Explore clear forms, tactile finishes and practical details across tableware, décor, accessories and thoughtfully described treats.</p>
            <Link to="/shop" className="btn-shop" onClick={toTop}>Shop Now</Link>
          </div>
        </section>

        <section className="promo-banner" style={{ backgroundImage: "url('/main/promo-homeware.webp')" }}>
          <div className="promo-content">
            <Link to="/shop" className="btn-promo" onClick={toTop}>shop the edit</Link>
          </div>
        </section>

        <section className="new-arrivals">
          <div className="container">
            <div className="section-header">
              <h2>New arrivals</h2>
              <p>Distinct materials, practical care notes, and a closer view from every angle.</p>
            </div>
            <div className="product-grid">
              {productData.slice(0, 8).map((product) => (
                <Link to={`/shopDetails/${product.id}`} onClick={toTop} key={product.id} className="product-card">
                  <div className="product-image">
                    <span className="tag-new">NEW</span>
                    <img src={product.image} alt={product.name} loading="lazy" />
                  </div>
                  <div className="product-info">
                    <h3>{product.name}</h3>
                    <p className="price">{formatMoney(product.price)}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="cellar-banner" style={{ backgroundImage: "url('/main/beverage-collection.webp')" }}>
          <div className="cellar-overlay">
            <div className="cellar-content">
              <h2>THE BOTTLE EDIT</h2>
              <p>Botanical refreshers and measured adult pours, with product facts that defer to the bottle supplied.</p>
              <p className="alcohol-notice">{ALCOHOL_NOTICE}</p>
              <Link to="/shop" className="btn-cellar" onClick={toTop}>VIEW THE COLLECTION</Link>
            </div>
          </div>
        </section>

        <section className="reviews-section">
          <div className="container">
            <h2>Material notes</h2>
            <div className="reviews-grid">
              <div className="review-card">
                <div className="user-info"><div className="avatar-placeholder">01</div><div className="details"><h4>Clear product facts</h4><p>Use, material and size</p></div></div>
                <p className="review-text">Every product page pairs the gallery with dimensions, finish, intended use and any expected material variation.</p>
              </div>
              <div className="review-card">
                <div className="user-info"><div className="avatar-placeholder">02</div><div className="details"><h4>Care that fits the object</h4><p>Practical handling guidance</p></div></div>
                <p className="review-text">Ceramic, glass, textile, food and electrical pieces each receive their own cleaning, storage and safety notes.</p>
              </div>
              <div className="review-card">
                <div className="user-info"><div className="avatar-placeholder">03</div><div className="details"><h4>Hosted payment</h4><p>No card fields in our form</p></div></div>
                <p className="review-text">Checkout validates delivery details, totals the cart and then hands card entry to the hosted payment page.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="interior-section">
          <div className="image-wrapper">
            <img src="/main/studio-shelves.webp" alt="A calm studio shelf with unbranded ceramics, textiles and lighting" loading="lazy" />
          </div>
        </section>
      </main>
      <button className="scroll-to-top" onClick={toTop} aria-label="Scroll to top">↑</button>
    </div>
  );
}

export default Main;
